<div
  *tdLoading="
    'duty-on-form';
    mode: 'indeterminate';
    type: 'circle';
    strategy: 'overlay';
    color: 'primary'
  "
>
  <div
    *ngIf="form"
    [formGroup]="form"
    gdAreas="dutyStart dutyStart base | comments comments aircraft | errors errors errors"
    gdGap="20px"
  >
    <kendo-textbox-container gdArea="dutyStart" floatingLabel="Duty on time">
      <kendo-dateinput
        [format]="dateTimeFormat"
        formControlName="dutyPeriodStartTime"
      ></kendo-dateinput>
    </kendo-textbox-container>
    <fl-message-box gdArea="errors" level="error" [messages]="errors$ | async"></fl-message-box>
    <fl-base-autocomplete-v2
      gdArea="base"
      hint="Required"
      [disableGoldenHourBases]="true"
      formControlName="baseId"
      (optionSelected)="onBaseSelected($event)"
    ></fl-base-autocomplete-v2>
    <fl-aircraft-autocomplete-v2
      gdArea="aircraft"
      hint="Required"
      formControlName="aircraftId"
    ></fl-aircraft-autocomplete-v2>
    <div gdArea="comments" fxLayout="column" fxLayoutGap="20px">
      <mat-form-field fxFlex fxFill *ngIf="restTimeLessThan10Hours$ | async">
        <textarea
          matInput
          matTextareaAutosize
          formControlName="restJustification"
          placeholder="10 Hour Rest Time Justification"
        ></textarea>
        <mat-error
          *ngIf="
            form?.controls.restJustification.errors
              ?.justificationRequiredForRestTimeLessThan10Hours as error
          "
          >{{ error.message }}</mat-error
        >
      </mat-form-field>
      <mat-form-field fxFill>
        <textarea
          matInput
          matTextareaAutosize
          formControlName="comments"
          placeholder="Comments"
          flex
        ></textarea>
      </mat-form-field>
    </div>
  </div>
</div>
